




































































import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator';
import {MediaUpload, MediaUploadState} from '@/modules/media/types';
import KeyValuePair from '@/modules/core/support/KeyValuePair';

@Component
export default class MediaUploadItem extends Vue {
    /**
     * Archivo de subida renderizado por el componente
     *
     * @var { MedaUpload }
     */
    @Prop({type: MediaUpload, default: () => new MediaUpload()})
    public upload: MediaUpload

    public statesMessages: KeyValuePair = {
        [MediaUploadState.Optimizing]: 'Optimizando',
        [MediaUploadState.Transferring]: 'Enviando',
        [MediaUploadState.WaitingResponse]: 'Enviando',
    }

    public get stateMessage () {
        return this.statesMessages[this.upload.state]
    }

    public get fileIcon (): string {
        switch (true) {
            case this.upload.isImage:
                return 'photo'
            case this.upload.isPDF:
                return 'mdi-file-outline'
            case this.upload.isVideo:
                return 'mdi-video'
            default:
                return 'mdi-file'
        }
    }
}
